"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_router_1 = require("react-router");
var bind_1 = require("../bind");
var with_update_url_1 = require("./with_update_url");
var SortSelect = /** @class */ (function (_super) {
    tslib_1.__extends(SortSelect, _super);
    function SortSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortSelect.prototype.sortChanged = function (evt) {
        var _a;
        evt.target.blur();
        var sort = evt.target.value;
        var paramName = this.props.sort.options[0].paramName;
        var newUrl = this.props.updateUrl(this.props.location, (_a = {}, _a[paramName] = sort, _a));
        this.props.router.push(newUrl);
    };
    SortSelect.prototype.render = function () {
        var sortOptions = this.props.sort.options.map(function (option) { return (React.createElement("option", { key: option.optionValue, value: option.optionValue }, option.name)); });
        var selected = this.props.sort.options.find(function (opt) { return opt.selected; });
        return (React.createElement("div", { className: "styled-dropdown styled-dropdown--fluid mb-0" },
            React.createElement("select", { onChange: this.sortChanged, value: selected && selected.optionValue, name: "sort", id: "sort" }, sortOptions)));
    };
    tslib_1.__decorate([
        bind_1.default
    ], SortSelect.prototype, "sortChanged", null);
    return SortSelect;
}(React.Component));
exports.SortSelect = SortSelect;
exports.default = react_router_1.withRouter(with_update_url_1.withUpdateURL(SortSelect));
//# sourceMappingURL=sort_select.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/sort_select.js
// module id = fEr4
// module chunks = 0 1 2 3 9 10 14 20